// extracted by mini-css-extract-plugin
export default {"sparkle":"AnimatedSparkle-module__sparkle__e5yfa","container":"AnimatedSparkle-module__container__KoAwK"};